import { websockets } from '../../engine/websockets-sidecar'
import { localStorer } from '../../lib/localStorer-sidecar'

export const version = '0.5.1'

export const isLocal = window.location.href.includes('localhost:')

// export const experimentalMultiplayer = true
export const skipVersionCheck = isLocal && false
export const useRemoteMultiplayer = !isLocal || true
export const multiplayerAutoJoin = true
export const multiplayerAutoSit = true
export const singleplayerAutoJoin = false

export const isDevMode = true && isLocal

export type ChessTestMode = 'normal' | 'game' | 'ai' | 'ai2'
const settingKey = '_chess_testmode'
export let testMode: ChessTestMode = 'game'
export const loadTestMode = (): ChessTestMode => {
  websockets.setMultiplayerAutoJoin(multiplayerAutoJoin)
  websockets.setUseRemoteMultiplayer(useRemoteMultiplayer)
  websockets.setSkipVersionCheck(skipVersionCheck)

  let loadedTestMode = localStorer.load(settingKey, 1) as
    | ChessTestMode
    | 'normal'
  return loadedTestMode
}
export const setTestMode = (tm: ChessTestMode) => {
  localStorer.save(settingKey, 1, tm)
  window.location.reload()
}
